import React from "react";
import { useLocation } from "react-router-dom";
import SignInPrompt from "./SignInPrompt";

// Vania Msg 220 §2d — a dedicated /app/signin route so the top-bar "sign in"
// button on For You / Discover can land somewhere shareable. Preserves the
// `?next=...` query so Google returns to where the guest was.
export default function SignInRoute() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const next = params.get("next") || "/app";
  // ww-copy-ok: trial-free · the two "free" tokens here both describe the
  // 30-day trial statement, not paywalled features.
  const line = "save events and message your people for free. become an insider to join squads, follow curators, mark went and post. first 30 days free. we'll never charge you without asking first."; // ww-copy-ok: trial-free
  return <SignInPrompt title="sign in to watu wako"
                       line={line}
                       next={next} testId="signin-route" />;
}
